import {PreferencesModel} from '../../models/api/preferencesModel';
import {ThunkAction} from '../../store/appThunk';
import {findPreferencesQueue} from './specializedTaskQueues';

export function pushPreferencesUpdatedTask(preferencesUpdate: PreferencesModel): ThunkAction {
  return async (dispatch, getState) => {
    const queue = findPreferencesQueue(dispatch, getState);

    // Wait for our turn to work.
    await queue.waitForTurnAsync();

    // Update the state.
    return queue.provideResultAsync({
      preferences: preferencesUpdate,
      updatedAt: preferencesUpdate.updatedAt,
    });
  };
}
